import { EMPTY_GUID } from "@techsharegov/react-ui";
import React from "react";
import { useParams } from "react-router-dom";

export type CommitteeProviderProps = {
  providedCommitteeId?: string;
};

export interface CommitteeState {
  committeeId: string;
}

const CommitteeStateContext = React.createContext<CommitteeState | undefined>(undefined);

function globalReducer(state: CommitteeState): CommitteeState {
  return {...state};
}

export const CommitteeProvider: React.FC<CommitteeProviderProps> = ({
  providedCommitteeId = EMPTY_GUID,
  children,
}) => {
  let { committeeId = providedCommitteeId } = useParams<any>();

  const [state] = React.useReducer(globalReducer, {
    committeeId: committeeId,
  });

  return (
    <CommitteeStateContext.Provider value={state}>
      {children}
    </CommitteeStateContext.Provider>
  );
};

export const useCommitteeState = () => {
  const globalStateContext = React.useContext(CommitteeStateContext);
  if (globalStateContext === undefined) {
    throw new Error('useCommitteeState must be used within a CommitteeProvider');
  }
  return globalStateContext;
};
